import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop — scrolls the window to top on every route change.
 * Mount once inside <BrowserRouter>. Skips scroll restore when the URL
 * contains a hash (so /home#ecosystem still anchors correctly).
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return; // preserve in-page anchor behaviour
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
